export default __webpack_public_path__ + "static/media/overviewBg.830d3222.png";